import OpenAI from "openai";

const OPENAI_API_KEY =
  "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";
export const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAPI_KEY, // This is the default and can be omitted
  dangerouslyAllowBrowser: true,
});
